import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  PersonalTimeSheet,
  Resource,
  TimeSheetFilter,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  timeSheet: PersonalTimeSheet;
  currentPage: number;
  canLoadMore: boolean;
  isDirty: boolean;
  retrievePersonalTimeSheet(
    request: Boundaries["retrievePersonalTimeSheet"]["request"],
  ): void;
}

function useRetrievePersonalTimeSheet(
  resource: Identifiable<Resource>,
  filter: TimeSheetFilter,
  size: number,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrievePersonalTimeSheetRequestPending(
        resource,
        filter,
        size,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrievePersonalTimeSheetRequestSuccess(
        resource,
        filter,
        size,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrievePersonalTimeSheetRequestFailure(
        resource,
        filter,
        size,
      ),
    ),
    timeSheet: useSelector(() =>
      selector.getPersonalTimeSheet(resource, filter, size),
    ),
    currentPage: useSelector(() =>
      selector.getPersonalTimeSheetCurrentPage(resource, filter, size),
    ),
    canLoadMore: useSelector(() =>
      selector.canLoadMorePersonalTimeSheet(resource, filter, size),
    ),
    isDirty: useSelector(() =>
      selector.isResourceTimeSheetDirty(resource, filter, size),
    ),
    retrievePersonalTimeSheet: core.retrievePersonalTimeSheet,
  };
}

export { useRetrievePersonalTimeSheet };
